(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/components/email-confirm.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/components/email-confirm.js');
'use strict';

const _svs$myProfile$consta = svs.myProfile.constants.thunkStatus,
  FULFILLED = _svs$myProfile$consta.FULFILLED,
  REJECTED = _svs$myProfile$consta.REJECTED;
const Button = svs.ui.ReactButton;
const _svs$myProfile$react$ = svs.myProfile.react.store.pdPreferences.actions,
  getCustomersPreferences = _svs$myProfile$react$.getCustomersPreferences,
  setForceSaveEmail = _svs$myProfile$react$.setForceSaveEmail,
  setVerifyEmail = _svs$myProfile$react$.setVerifyEmail;
const _svs$myProfile$react$2 = svs.myProfile.react.shared.dialogs,
  showTechnicalError = _svs$myProfile$react$2.showTechnicalError,
  showHandledError = _svs$myProfile$react$2.showHandledError,
  showBaseError = _svs$myProfile$react$2.showBaseError;
const _svs$myProfile$react$3 = svs.myProfile.react.pages.myInformation.myInformation.emailDialogs,
  showResendConfirmationDialog = _svs$myProfile$react$3.showResendConfirmationDialog,
  showAlreadyVerifed = _svs$myProfile$react$3.showAlreadyVerifed;
const putEmailVerifyAsync = svs.myProfile.react.pages.myInformation.myInformationService.putEmailVerifyAsync;
const trackEventEmailConfirmation = () => {
  const track = {
    category: 'My Profile',
    action: 'new email confirmation'
  };
  svs.components.analytics.trackEvent(track);
};
const trackEventEmailLink = () => {
  const track = {
    category: 'My Profile',
    action: 'new email link'
  };
  svs.components.analytics.trackEvent(track);
};

const EmailConfirm = () => {
  const dispatch = ReactRedux.useDispatch();
  const _ReactRedux$useSelect = ReactRedux.useSelector(state => state.playerPreferences),
    playerPreferences = _ReactRedux$useSelect.playerPreferences;
  const email = playerPreferences.email,
    cid = playerPreferences.cid;
  const _ref = (playerPreferences === null || playerPreferences === void 0 ? void 0 : playerPreferences.playerPreferencesStatus) || {},
    playerPreferencesStatus = _ref.status;
  React.useEffect(() => {
    dispatch(getCustomersPreferences());
  }, [dispatch]);
  React.useEffect(() => {
    if (playerPreferencesStatus === FULFILLED || playerPreferencesStatus === REJECTED) {
      if (!cid) {
        showTechnicalError();
      }
    }
  }, [cid, playerPreferencesStatus]);
  const showDefaultError = () => {
    showTechnicalError('Ett fel inträffade när ett nytt e-postmeddelande skulle skickas, försök igen senare eller kontakta Kundservice 0770 - 11 11 11');
  };
  const handleError = error => {
    const code = error.code;
    if (code === 12510) {
      showAlreadyVerifed();
      dispatch(setVerifyEmail());
    } else if (code === 12530) {
      showBaseError("Du har nyligen best\xE4llt en bekr\xE4ftelsel\xE4nk till ".concat(email.toLowerCase()), 'Kontrollera din skräppost om du inte hittar mejlet. Om 15 minuter kan du begära en ny länk.');
    } else if (code === 100005) {
      showHandledError("Du har blivit utloggad. Var god logga in och f\xF6rs\xF6k igen!");
    } else {
      svs.myProfile.logger.warn("Unhandled error code when sending email confirmation link: ".concat(error));
      showDefaultError();
    }
  };
  const handleSendConfirmationEmail = async () => {
    try {
      const _await$putEmailVerify = await putEmailVerifyAsync(),
        error = _await$putEmailVerify.error;
      if (error) {
        return handleError(error);
      }
      trackEventEmailConfirmation();
      showResendConfirmationDialog();
    } catch (error) {
      svs.myProfile.logger.warn("Unhandled error code when sending email confirmation link: ".concat(error));
      showDefaultError();
    }
  };
  const handleChangeEmail = () => {
    trackEventEmailLink();
    dispatch(setForceSaveEmail(true));
  };
  return React.createElement(React.Fragment, null, React.createElement("p", {
    className: "f-center margin-top-2"
  }, "Bekr\xE4fta din e-post genom att anv\xE4nda l\xE4nken vi har skickat till adressen du har angivit ."), React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    onClick: handleSendConfirmationEmail,
    transparent: true
  }, "Skicka ny bekr\xE4ftelsel\xE4nk"), React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    onClick: handleChangeEmail,
    transparent: true
  }, "Ange ny e-post"));
};
svs.myProfile.react.pages.myInformation.myInformation.email.EmailConfirm = EmailConfirm;

 })(window);